import { defineMessages } from 'react-intl';

const messageId = (id: string) => `page.admin.settings.storage.${id}`;

export default defineMessages({
  filesHeader: {
    id: messageId('table.header.files'),
    defaultMessage: 'Files',
  },
  storageBucket: {
    id: messageId('table.header.storageBucket'),
    defaultMessage: 'S3 Bucket',
  },
  storageLocation: {
    id: messageId('table.header.storageLocation'),
    defaultMessage: 'S3 Bucket Location',
  },

  storagePathPrefix: {
    id: messageId('table.header.storagePathPrefix'),
    defaultMessage: 'Storage Path Prefix',
  },
  verified: {
    id: messageId('table.header.verified'),
    defaultMessage: 'Verified',
  },
  notVerified: {
    id: messageId('status.notVerified'),
    defaultMessage: 'Not verified',
  },
  originalFiles: {
    id: messageId('table.body.originalFiles'),
    defaultMessage: 'Original Files',
  },
  storageBucketPlaceholder: {
    id: messageId('table.body.storageBucketPlaceholder'),
    defaultMessage: 'Leave empty for Default Storage',
  },
  imageConversions: {
    id: messageId('table.body.imageConversions'),
    defaultMessage: 'Image conversions',
  },
  videoTranscodes: {
    id: messageId('table.body.videoTranscodes'),
    defaultMessage: 'Video transcodes',
  },
  intro: {
    id: messageId('intro'),
    defaultMessage:
      'Choose where FileSpin stores each class of files. Leave a bucket empty to use FileSpin-managed storage. Buckets are validated after you save — a green “Verified” badge means FileSpin can read and write to it.',
  },
  pathPrefixPlaceholder: {
    id: messageId('pathPrefixPlaceholder'),
    defaultMessage: 'e.g. assets/originals',
  },
  regionPlaceholder: {
    id: messageId('regionPlaceholder'),
    defaultMessage: 'Select region',
  },
  originalFilesDesc: {
    id: messageId('desc.originalFiles'),
    defaultMessage: 'Your uploaded source files.',
  },
  imageConversionsDesc: {
    id: messageId('desc.imageConversions'),
    defaultMessage: 'Generated image renditions and thumbnails.',
  },
  videoTranscodesDesc: {
    id: messageId('desc.videoTranscodes'),
    defaultMessage: 'Generated video transcodes and HLS renditions.',
  },
});
